import { css } from "../../../../styled-system/css";

export const styles = {
  divWrapper: () =>
    css({
      width: "100%",
      backgroundColor: "white",
    }),
};
